import React from "react";
import { Route, Redirect } from "react-router-dom";

import TCEs from "@/pages/Admin/Documentos/TCEs";

export default function TCEsRoute({ auth, ...rest }) {
  // idenficar se o usuario está logado
  const { authenticated, data } = auth;

  if (!authenticated) {
    return (
      <Route
        {...rest}
        render={props => <Redirect to={{ pathname: "/login" }} />}
      />
    );
  }

  const { tipo } = data;
  let Component;

  switch (true) {
    case ["administrador"].includes(tipo):
      Component = TCEs;
      break;
  }

  return <Route {...rest} render={props => <Component {...props} />} />;
}
